import module from 'finanzas/module.js'
import * as moment from 'moment'

const schema = {
  id_moneda: 'number',
  adeudo: 'number',
  activo: 'boolean',
}

export class FinanzasSaldoEmpleadosService {
  constructor ($http) {
    this.$http = $http
  }

  get (proyectos, fechaCorte) {
    return this.$http.get('/kendu/finanzas/saldoEmpleados/seleccionar', {
      params: {
        companies: proyectos,
        date: moment(fechaCorte).format('YYYY-MM-DD'),
      },
      schema,
    })
  }

  exportar (proyectos, fechaCorte) {
    return this.$http.get('/kendu/finanzas/saldoEmpleados/exportar', {
      params: {
        companies: proyectos,
        date: moment(fechaCorte).format('YYYY-MM-DD'),
      },
      download: true,
    })
  }
}

module.service('FinanzasSaldoEmpleados', FinanzasSaldoEmpleadosService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasSaldoEmpleados.js